import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'students',
    lazy: async () => ({ Component: (await import('./StudentsPage')).StudentsPage }),
  },
  {
    path: 'students/:studentId',
    lazy: async () => ({ Component: (await import('./StudentPage')).StudentPage }),
  },
];
